import { configureStore } from "@reduxjs/toolkit";
import HeaderReducer from "./Header/index.js"
import SetWeb from "./SetWeb/index.js";
export default configureStore({
    reducer: {
        counter: HeaderReducer,
        SetWeb: SetWeb,
    }
})
